'use strict';
module.exports = [
  require('./erf')
];



//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/function/special/index.js
// module id = 1835
// module chunks = 0